import React from 'react';

export function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 py-3">
        <p className="text-center text-sm text-muted-foreground">
          © {currentYear} Created by <strong>Muhammad Akbar Abdullah</strong>
        </p>
      </div>
    </footer>
  );
}
